export const ACCOUNTING_ROLE_NAME = 'Accounting';

export function isAccountingRole(role: { name?: string } | null | undefined): boolean {
  return role?.name === ACCOUNTING_ROLE_NAME;
}

export function isElevatedRole(role: { name?: string } | null | undefined): boolean {
  return role?.name === 'Admin' || role?.name === 'SystemAdmin';
}

export function isReportOnlyUser(roles: { name?: string }[]): boolean {
  const hasAccounting = roles.some((r) => isAccountingRole(r));
  const hasElevated = roles.some((r) => isElevatedRole(r));
  return hasAccounting && !hasElevated;
}
